"use strict";function setDeviceProperties$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.setDeviceProperties$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.iot.setDeviceProperties";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.42"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.42"},_a)),exports.setDeviceProperties$=setDeviceProperties$,exports.default=setDeviceProperties$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/iot/setDeviceProperties.js
// module id = 960
// module chunks = 106